import { createAxios, createAxiosHeaders } from "./axiosHttpMarconi";

export const storageService = {
  getFiles,
  uploadFile,
  deleteFile,
  downloadFile,
  replaceFile,
};

function getFiles(filters) {
  const axios = createAxios();
  let urlPath = `/files-storage`;
  const params = new URLSearchParams(filters);

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function uploadFile(req) {
  const axios = createAxios();
  const formData = new FormData();
  const { file, container, path } = req.body;

  formData.append("adjunto", file);
  formData.append(
    "request",
    JSON.stringify({
      container: container,
      path: path,
    })
  );
  let urlPath = `/files-storage`;
  return axios.post(urlPath, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function deleteFile(container, path) {
  const axios = createAxios();
  const encodedTail = encodeURI(path).replace(/#/g, "%23");
  let urlPath = `/files-storage/${container}/${encodedTail}`;
  return axios.delete(urlPath);
}

function replaceFile(container, old_path, { file, path }) {
  const axios = createAxios();
  const formData = new FormData();
  formData.append("adjunto", file);
  formData.append(
    "request",
    JSON.stringify({
      container: container,
      path: path,
    })
  );

  const encodedTail = encodeURI(old_path).replace(/#/g, "%23");
  let urlPath = `/files-storage/${container}/${encodedTail}`;
  return axios.put(urlPath, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function downloadFile(container, path) {
  const axios = createAxiosHeaders();
  const encodedTail = encodeURI(path).replace(/#/g, "%23");
  let urlPath = `/files-storage/${container}/${encodedTail}`;
  return axios.get(urlPath, { responseType: "blob" }).then((response) => {
    const contentDisposition = response.headers["content-disposition"];
    const fileName = contentDisposition;
    return Promise.resolve({ blob: response.data, fileName: fileName });
  });
}
